
























































import { RulesCard } from '@/components/rules';
import { ActivitiesItem } from '@/components/rules/card-items';
import { ActivityIcon } from '@/components';
import { ActivityGroup, ActivityType, Skill, ActivitySubtype } from '@/models';
import Vue from 'vue';

interface ActivityTypeWithSkill extends ActivityType {
  skill: string;
  parent?: ActivityType;
}

export default Vue.extend({
  name: 'ActivitiesCards',
  components: {
    ActivityIcon,
    ActivitiesItem,
    RulesCard: () => Promise.resolve(RulesCard),
  },
  props: {
    data: Array as () => ActivityGroup[],
  },
  computed: {
    // This method would flattten all activities and subactivities (if there are any)
    // into a single array in order to display all of them in cards as separate items (mobile)
    activitiesOrSubactivities(): ActivityTypeWithSkill[] {
      return this.data.reduce((allItemsInSkills: ActivityTypeWithSkill[], currentSkill: ActivityGroup) => {
        const activitiesWithSkills = currentSkill.activityTypes
          .reduce((allItemsInActivities: ActivityTypeWithSkill[], activityType: ActivityType) => {
            let allActivityTypes: ActivityTypeWithSkill[] = [
              {...activityType, skill: currentSkill.skill},
            ];

            if (activityType.subtypes!.length) {
              allActivityTypes = activityType.subtypes!
                .map(s => ({...s, gxp: s.rewardGxp, skill: currentSkill.skill, parent: activityType}));
            }

            return allActivityTypes.concat(allItemsInActivities);
          }, []);

        return allItemsInSkills.concat(activitiesWithSkills);
      }, []);
    },
  },
});
